type ImpactProposal = {
  clauseId: string;
  proposedValue?: unknown;
  originalValue?: unknown;
  createdAt?: string | Date;
  updatedAt?: string | Date;
};

const PRICE_CLAUSES = new Set(['purchase-price', 'offer-price']);
const CREDIT_CLAUSES = new Set([
  'seller-assistance-amount',
  'seller-assistance',
]);

const time = (p: ImpactProposal) =>
  new Date((p.updatedAt || p.createdAt || 0) as string).getTime() || 0;

/**
 * Net change to what the seller nets, from the open price and seller-credit
 * proposals: price change minus seller-credit change. (Previously a bigger
 * seller credit was added as if it were a higher offer, and older proposals
 * on the same clause were summed too.)
 */
export function netPriceImpact(proposals: ImpactProposal[]): number {
  const latest = new Map<string, ImpactProposal>();
  for (const p of proposals) {
    if (!PRICE_CLAUSES.has(p.clauseId) && !CREDIT_CLAUSES.has(p.clauseId)) {
      continue;
    }
    const prev = latest.get(p.clauseId);
    if (!prev || time(p) >= time(prev)) latest.set(p.clauseId, p);
  }
  let impact = 0;
  for (const p of latest.values()) {
    const delta =
      (Number(p.proposedValue) || 0) - (Number(p.originalValue) || 0);
    impact += PRICE_CLAUSES.has(p.clauseId) ? delta : -delta;
  }
  return impact;
}
